module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1204
// module chunks = 0